import React from "react";

const Button = ({ children, className = "", ...props }) => (
  <button
  className={`rounded-md bg-[var(--primary-color)] px-4 py-2 text-sm font-medium text-white hover:bg-opacity-90 ${className}`}
    {...props}
  >
    {children}
  </button>
);

export default Button;
